/* =================== AUTENTICADOR =================== */

var codigo1 = 0;
var codigo2 = 0;
var codigo3 = 0;
var codigo4 = 0;

jQuery(document).ready(function ($) {
  $("#campo1").keyup(function (e) {
    if ($("#campo1").val() != "") {
      $("#campo2").focus();
    }
    codigo1 = $("#campo1").val();
    VerificaCampos();
  });
  $("#campo2").keyup(function (e) {
    if ($("#campo2").val() != "") {
      codigo2 = $("#campo2").val();
    }
    $("#campo3").focus();
    VerificaCampos();
  });
  $("#campo3").keyup(function (e) {
    if ($("#campo3").val() != "") {
      codigo3 = $("#campo3").val();
    }
    $("#campo4").focus();
    VerificaCampos();
  });
  $("#campo4").keyup(function (e) {
    codigo4 = $("#campo4").val();
    VerificaCampos();
  });
});

function cancatenaCod() {
  var listaCodigos = codigo1 + codigo2 + codigo3 + codigo4;
  $("#verifica_codigo").val(listaCodigos);
}

function VerificaCampos() {
  if (
    $("#campo1").val() != "" &&
    $("#campo2").val() != "" &&
    $("#campo3").val() != "" &&
    $("#campo4").val() != ""
  ) {
    cancatenaCod();
  }
}
